import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Driver } from '@app/shared/models/driver.model';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { DriverQuery } from '../models/driver-query.model';
import { PagedResult } from '@app/shared';

@Injectable()
export class DriversService {
  private http = inject(HttpClient);
  private baseUrl = environment.apiUrl + 'Drivers';

  getDriversPaginated(
    serviceProviderId: string,
    searchKeyword: string,
    pageIndex: number = 0,
    pageSize: number = 10
  ): Observable<any> {
    const params = {
      serviceProviderId,
      searchKeyword,
      pageIndex: pageIndex.toString(),
      pageSize: pageSize.toString(),
    };
    return this.http.get(`${this.baseUrl}/paginated`, { params });
  }

  getDriversList(query: DriverQuery): Observable<PagedResult<Driver>> {
    const params = this.buildQueryParams(query);
    return this.http.get<PagedResult<Driver>>(`${this.baseUrl}/list`, {
      params,
    });
  }

  exportDrivers(query: DriverQuery): Observable<Blob> {
    const params = this.buildQueryParams(query);
    return this.http.get(`${this.baseUrl}/export`, {
      params,
      responseType: 'blob',
    });
  }

  private buildQueryParams(query: DriverQuery): HttpParams {
    let params = new HttpParams()
      .set('serviceProviderId', query.serviceProviderId)
      .set('pageIndex', query.pageIndex?.toString() ?? '1')
      .set('pageSize', query.pageSize?.toString() ?? '10');

    if (query.sortBy !== undefined) {
      params = params.set('sortBy', query.sortBy.toString());
    }
    if (query.searchKey !== undefined) {
      params = params.set('searchKey', query.searchKey.toString());
    }
    if (query.search) {
      params = params.set('search', query.search);
    }

    return params;
  }

  getDriverById(driverId: number): Observable<Driver> {
    return this.http.get<Driver>(`${this.baseUrl}/${driverId}`);
  }

  addDriver(data: FormData): Observable<Driver> {
    return this.http.post<Driver>(this.baseUrl, data);
  }

  updateDriver(driverId: number, data: FormData): Observable<Driver> {
    return this.http.put<Driver>(`${this.baseUrl}/${driverId}`, data);
  }

  deleteDriver(driverId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.baseUrl}/${driverId}`);
  }
}
